import { render } from "./SaleDetail.vue?vue&type=template&id=c85a8470&scoped=true"
import script from "./SaleDetail.vue?vue&type=script&lang=js"
export * from "./SaleDetail.vue?vue&type=script&lang=js"

import "./SaleDetail.vue?vue&type=style&index=0&id=c85a8470&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85a8470"]])

export default __exports__